import React from "react";
import { Link } from "react-router-dom";

interface SideNavProp {
  path: string;
  icon: string;
  children: any;
}

const SideNav: React.FC<SideNavProp> = ({ path, icon, children }) => {
  return (
    <li className="nav-item">
      <Link className="nav-link" to={path}>
        <i className={`fas fa-fw ${icon}`}></i>
        <span>{children}</span>
      </Link>
    </li>
  );
};
// fa-tachometer-alt
export default SideNav;
